import { render, staticRenderFns } from "./WillOtherAssetsPartnerYN.vue?vue&type=template&id=71c36475"
import script from "./WillOtherAssetsPartnerYN.vue?vue&type=script&lang=js"
export * from "./WillOtherAssetsPartnerYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports